import Repository from "../../repository";

export default {
    GetStationRightByInfos: (payload) => Repository.post(`/api/StationRights/GetStationRightByInfos`, payload),
    EditStationRightByInfos: (payload) => Repository.post(`/api/StationRights/EditStationRightByInfos`, payload),
    GetStationRightByMonitorings: (payload) => Repository.post(`/api/StationRights/GetStationRightByMonitorings`, payload),
    EditStationRightByMonitorings: (payload) => Repository.post(`/api/StationRights/EditStationRightByMonitorings`, payload),
}
